import { SystemStyleObject } from "@chakra-ui/react";

export const businessDetailsTabCardCss: SystemStyleObject = {
  backgroundColor: "#FFFFFF",
  borderRadius: "20px",
  padding: "24px",
  boxShadow: "0px 0px 5px 0px #0000000D",
};
